export default __webpack_public_path__ + "static/media/loginVector.94829b16.png";